import type { FC } from 'react'
import { Icon } from 'ui'
import { useTranslation } from 'react-i18next'
import { MIN_CHARACTERS_REPHRASING } from '../../../../utils/constants'
import { useUser } from '../../../../contexts'

export const SuggestionPannelHeader: FC<{
  suggestionCount: number
  documentLength: number
}> = ({ suggestionCount, documentLength }) => {
  const userManager = useUser()
  const { t } = useTranslation()

  const isUserPremium = userManager.user?.is_premium

  const showAdvancedSuggestionsTitle =
    !isUserPremium &&
    !suggestionCount &&
    documentLength > MIN_CHARACTERS_REPHRASING

  const suggestionCountText =
    suggestionCount > 0 ? `(${suggestionCount.toString()})` : ''

  return (
    <div className="h-15 p-4 border-b border-neutral-200">
      {showAdvancedSuggestionsTitle ? (
        <div className="text-blue-correcto-800 font-bold flex items-center text-small">
          <div className="pr-2">
            <Icon icon="target" size="md" />
          </div>
          {t('Sugerencias avanzadas')}
        </div>
      ) : (
        <span className="text-blue-correcto-800 font-bold flex items-center text-small">
          {t('Sugerencias')} {suggestionCountText}
        </span>
      )}
    </div>
  )
}
